invalidWorkerResult